import { Archive, Block, CheckCircle, History, Restore } from '@mui/icons-material';
import MoreVert from '@mui/icons-material/MoreVert';
import { CircularProgress, IconButton, ListItemIcon, ListItemText, Menu } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { DeleteIcon, EditIcon, PendingIcon } from 'components/CustomIcons';
import useDeliverableService from 'features/Deliverables/hooks/useDeliverableService';
import useDeliverableRights from 'hooks/rights/useDeliverableRights';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { selectAllDeliverablesAction, selectDeliverableAction } from 'store/actions/deliverableActions';
import { openDialogAction } from 'store/actions/dialogsActions';
import { openDrawerAction } from 'store/actions/drawerActions';
import { addLoadingAction, removeLoadingAction } from 'store/actions/loadingsActions';
import { useSelector } from 'store/hooks';
import useUserRoles from 'hooks/useUserRoles';
import { useAppState } from 'store/Provider';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import { MissionAdvancementPossibilities } from 'types/enums/MissionAdvancementPossibilities';
import { setSnackbarAction } from 'store/actions/snackbarActions';
import ChangeBaseLineAPIServices from 'api/ChangeBaseLineAPIServices';
import { filterTotalFlagAction } from 'store/actions/changeBaselineActions';
import useBaseLineOrderWorkunitApi from 'features/ChangeBaseline/ChangeBaselinePages/services/useBaseLineOrderWorkunitApi';

const ActionsCell = React.memo((row: OrderWorkunit) => {
  const [t] = useTranslation();
  const { dispatch } = useAppState();
  // const userRoles = useUserRoles();
  // const appState = useSelector((state) => state.app);
  const loadings = useSelector((state) => state.loadings);
  const deliverableRights = useDeliverableRights([row]);
  const changeBaseline = useSelector((state) => state.changeBaseline);
  // const clientConnection = useSelector((state) => state.deliverable.order?.client_connection);
  // const orderType = useSelector((state) => state.deliverable.order?.order_type_id);
  // const scopes = useSelector((state) => state.catalogToOrder.scopes);
  const { changeMissionAdvancement, restoreDeliverables, handleDeliverableCancelComment } = useDeliverableService();

  const { EditTotalBaseLineWorkunit } = useBaseLineOrderWorkunitApi();

  // const userIsBm = appState.roles?.toString().includes('bm');
  // const userIsDC = appState.roles?.toString().includes('delivery_coordinator');
  // const userIsDM = appState.roles?.toString().includes('delivery_manager');
  // const userIsCustomer = appState.user?.is_client;
  // const userIsConsultant = appState.roles?.toString().includes('consultant');

  const [anchorMenuActionEl, setAnchorMenuActionEl] = React.useState<null | HTMLElement>(null);

  const handleMenuActionOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorMenuActionEl(event.currentTarget);
  };

  const handleMenuActionClose = () => {
    setAnchorMenuActionEl(null);
  };

  const stateReportMode = useSelector((state) => state.deliverable.isTableInReportMode);

  const handleActions = async (item: any) => {
    if (stateReportMode) {
      dispatch(openDialogAction({ name: 'deliverableCancelReportMode', data: { confirm: () => confirmAction(item) } }));
    } else {
      await confirmAction(item);
    }
    async function confirmAction(item: any) {
      dispatch(addLoadingAction(`action${item.label}`));
      // dispatch(selectDeliverableAction(row.id));
      await item.action();
      dispatch(removeLoadingAction(`action${item.label}`));
      handleMenuActionClose();
    }
  };

  const cancelDeleteAction = useCallback(async () => {
    let newLabel = row.label;
    if (row.label?.includes('Deleted')) {
      const updatedStatus = row.label.split('|').slice(0, -1).join('|');
      newLabel = updatedStatus;
    }
    const delete_workunitFlag = true;
    const savedDeliverables = {
      ...row,
      label: newLabel,
      status: 1,
      workunit_type: 'single',
      is_archived: delete_workunitFlag,
      source_order_id: Number(changeBaseline?.sourceOrder?.id),
      page_typeid: 3,
    };

    // await restoreChangebaseline([row]);
    await EditTotalBaseLineWorkunit(
      Number(changeBaseline?.baseLineOrder?.id),
      savedDeliverables,
      Number(changeBaseline?.sourceOrder?.id)
    );
  }, [restoreDeliverables, row]);

  const restoreAction = useCallback(async () => {
    let newLabel = row.label;

    if (row.label?.includes('cancelled')) {
      const updatedStatus = row.label.split('|').slice(0, -1).join('|');
      newLabel = updatedStatus;
    }
    const savedDeliverables = {
      ...row,
      label: newLabel,
      cancellation_reason: null,
      status: 1,
      workunit_type: 'single',
      source_order_id: Number(changeBaseline?.sourceOrder?.id),
      page_typeid: 3,
    };

    // await restoreChangebaseline([row]);
    await EditTotalBaseLineWorkunit(
      Number(changeBaseline?.baseLineOrder?.id),
      savedDeliverables,
      Number(changeBaseline?.sourceOrder?.id)
    );
    // const res = await ChangeBaseLineAPIServices.updateBaseLineWorkunit(Number(changeBaseline?.baseLineOrder?.id), {
    //   ...savedDeliverables,
    //   order_id: Number(changeBaseline?.sourceOrder?.id),
    // });
    // if (res) {
    //   dispatch(filterTotalFlagAction(true));
    // }
  }, [restoreDeliverables, row]);

  const editAction = useCallback(() => {
    dispatch(openDialogAction({ name: 'changeBaselineeditworkunitDialog', data: { data: row?.id, type: 'single' } }));

    // dispatch(selectAllDeliverablesAction(false));
    // dispatch(openDrawerAction({ name: 'deliverableEdit', data: [row.id] }));
  }, [dispatch, row.id]);

  const deleteAction = useCallback(() => {
    const delete_workunitFlag = true;
    const savedDeliverables = {
      ...row,
      label: `${row.label}|Deleted`,
      is_archived: delete_workunitFlag,
      status: 1,
      workunit_type: 'single',
      source_order_id: Number(changeBaseline?.sourceOrder?.id),
      page_typeid: 3,
    };
    dispatch(openDialogAction({ name: 'deliverableBaseLineDelete', data: savedDeliverables }));
  }, [dispatch, row]);

  const modifyNewwuAction = useCallback(async () => {
    const savedDeliverables = {
      ...row,
      label: `${row.label}|New WU`,
      status: 1,
      workunit_type: 'single',
      source_order_id: Number(changeBaseline?.sourceOrder?.id),
      page_typeid: 3,
    };
    await EditTotalBaseLineWorkunit(
      Number(changeBaseline?.baseLineOrder?.id),
      savedDeliverables,
      Number(changeBaseline?.sourceOrder?.id)
    );
  }, [restoreDeliverables, row.id]);

  const canManagersEditDeliverables = (deliverables: OrderWorkunit[]) =>
    deliverables.every(
      (deliverable) =>
        ((deliverable.mission_advancement_id &&
          deliverable.mission_advancement_id < MissionAdvancementPossibilities.REFUSED_CLIENT) ||
          !deliverable.mission_advancement_id) &&
        !isDeliverableCancelled(deliverable)
    );

  const isDeliverableCancelled = (deliverable: OrderWorkunit) => deliverable?.label?.includes('cancelled');
  const menuItems = useMemo(
    () => [
      {
        action: editAction,
        label: 'edit',
        permission: !row?.label?.includes('Deleted'),
        icon: <EditIcon sx={{ color: 'text.primary' }} fontSize="small" />,
      },
      {
        action: deleteAction,
        label: 'delete',
        icon: <DeleteIcon color="error" fontSize="small" />,
        isError: true,
        permission:
          row?.mission_advancement_id === null &&
          ![1, 2, 3, 4, 5, 6, 7].includes(row?.mission_advancement_id as any) &&
          !row?.label?.includes('Deleted'),
      },
      {
        action: restoreAction,
        label: 'restore',
        permission: deliverableRights.canRestore && !row?.label?.includes('Deleted'),
        icon: <Restore sx={{ color: 'text.primary' }} />,
      },
      {
        action: cancelDeleteAction,
        label: 'Cancel Delete',
        permission: deliverableRights.canCancelDelete || row?.label?.includes('Deleted'),
        icon: <Restore sx={{ color: 'text.primary' }} />,
      },
      {
        action: modifyNewwuAction,
        label: 'New WU',
        permission: row?.label === 'added',
        icon: <PendingIcon sx={{ color: 'text.primary' }} fontSize="small" />,
      },

    ],
    [editAction, deleteAction, restoreAction, cancelDeleteAction, modifyNewwuAction, row]
  );

  const menuItemsAvailables = useMemo(() => menuItems.filter((item) => item.permission !== false), [menuItems]);
  // const disableActions = !menuItemsAvailables.length || [5, 6, 7].includes(Number(row?.mission_advancement_id));
  // ||
  // row?.label?.includes('Deleted');

  return (
    <>
      <IconButton onClick={handleMenuActionOpen} size="large">
        <MoreVert />
      </IconButton>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorMenuActionEl}
        open={Boolean(anchorMenuActionEl)}
        onClose={handleMenuActionClose}
      >
        {menuItemsAvailables.map((item) => (
          <MenuItem key={item.label} onClick={() => handleActions(item)} disabled={!!loadings[`action${item.label}`]}>
            <ListItemIcon>
              {loadings[`action${item.label}`] ? <CircularProgress size="1.5rem" color="inherit" /> : item.icon}
            </ListItemIcon>
            <ListItemText sx={{ color: !item.isError ? '' : 'error.main' }}>{t(item.label)}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});

export default ActionsCell;
